module.exports = __webpack_public_path__ + "img/upload.5b24c546.svg";